module.exports = "<div class=p-v> <div class=md-list-item-text style=width:370px> <p ng-class=productsVm.productText(product) class=\"text-color no-margin exo\"> <strong>{{ product.name }}</strong> </p> <p ng-class=productsVm.productText(product) class=\"text-sm no-margin proxima\"> {{ product.itemProductName }} - {{product.subItemProductName}} </p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/research/products/list/jobs/list-data-products.html
// module id = 687
// module chunks = 0